var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{
    'btn-primary': _vm.level == 'primary',
    'btn-danger': _vm.level == 'danger',
    'btn-warning': _vm.level == 'warning',
    'btn-sm': _vm.small,
    'btn-xs': _vm.extraSmall,
    'btn-block': _vm.block
  },attrs:{"type":"button","data-style":"zoom-out","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.buttonClicked.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }